import React, { useState } from 'react';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import TextArea from 'antd/lib/input/TextArea';
import { AutoCompleteInputIntern } from 'components/community/acceptance/components/AutoCompleteIntern';
import { AutoCompleteInputMajor } from 'components/community/acceptance/components/AutoCompleteMajor';
import { AutoCompleteInputUniv } from 'components/community/acceptance/components/AutoCompleteUniv';
import { AutoCompleteInputWorker } from 'components/community/acceptance/components/AutoCompleteWorker';
import {
  communityAutoCompleteCompanyName,
  communityAutoCompleteMajorName,
  communityAutoCompleteUniversityName,
} from 'libs/api/community';
import { Form, Select, Input, Button } from 'antd';
import styled from 'styled-components';
import { device } from 'GlobalStyles';
import AttachmentModal from '../acceptance/components/AttachmentModal/AttachmentModal';

type TWidth = {
  mobileWidth?: string;
};

const PassQualiticationWrite = ({ form }: any) => {
  const [intern, setIntern] = useState(false);
  const [worker, setWorker] = useState(false);
  const [isOnAttachmentModal, setIsOnAttachmentModal] = useState(false);

  return (
    <StyledContainer>
      <StyledRow>
        <div className='halfWidth'>
          <div className='label'>학교명</div>
          <Form.Item
            className='form-item community-selector'
            name='university_name'
            rules={[{ required: true }]}
          >
            <AutoCompleteInputUniv
              board='community'
              promise={communityAutoCompleteUniversityName}
              form={form}
              name='university_name'
            >
              <Input autoComplete='off' size='large' placeholder='서울대학교' name='university_name' />
            </AutoCompleteInputUniv>
          </Form.Item>
          <Form.Item
            name='university_id'
            style={{ width: '1px', height: '1px', position: 'absolute', opacity: 0 }}
          >
            <Input name='university_id' />
          </Form.Item>
        </div>

        <div className='halfWidth'>
          <div className='label'>전공</div>
          <Form.Item className='form-item community-selector' name='major_name' rules={[{ required: true }]}>
            <AutoCompleteInputMajor
              board='community'
              promise={communityAutoCompleteMajorName}
              form={form}
              name='major_name'
            >
              <Input autoComplete='off' size='large' placeholder='경제학과' />
            </AutoCompleteInputMajor>
          </Form.Item>
          <Form.Item
            name='major_id'
            style={{ width: '1px', height: '1px', position: 'absolute', opacity: 0 }}
          >
            <Input />
          </Form.Item>
        </div>
      </StyledRow>

      <StyledRow mobileWidth='row'>
        <div className='halfWidth'>
          <div className='label'>학점</div>
          <Form.Item className='form-item community-selector' name='my_score' rules={[{ required: true }]}>
            <Input autoComplete='off' size='large' placeholder='학점' />
          </Form.Item>
        </div>

        <div className='halfWidth'>
          <div className='label'>총점</div>
          <Form.Item className='form-item community-selector' name='total_score' rules={[{ required: true }]}>
            <Select placeholder='총점'>
              <Select.Option value='4.5'>4.5</Select.Option>
              <Select.Option value='4.3'>4.3</Select.Option>
              <Select.Option value='4.0'>4.0</Select.Option>
            </Select>
          </Form.Item>
        </div>
      </StyledRow>

      <StyledRow>
        <div className='fullWidth' style={{ display: 'flex', flexDirection: 'column' }}>
          <div className='label' style={{ display: 'flex', justifyContent: 'space-between' }}>
            인턴경력
            <Checkbox
              className='green-border-checkbox'
              onChange={() => {
                setIntern((prev) => !prev);
                !intern && form.setFieldsValue({ experienced_interns: [] });
              }}
            >
              없음
            </Checkbox>
          </div>
          <Form.List name='experienced_interns'>
            {(fields, { add, remove }) => (
              <>
                {fields.map((field, index) => (
                  <Form.Item key={field.key} noStyle={true}>
                    <Form.Item
                      className='form-item community-selector'
                      name={[field.name, 'experienced_intern_name']}
                      rules={[{ required: true }]}
                    >
                      <AutoCompleteInputIntern
                        board='community'
                        defaultValue={
                          form.getFieldValue('experienced_interns')[field.name]['experienced_intern_name']
                        }
                        promise={communityAutoCompleteCompanyName}
                        form={form}
                        name={[field.name, 'experienced_intern_name']}
                        fieldIndex={field.name}
                      >
                        <Input
                          disabled={intern}
                          autoComplete='off'
                          size='large'
                          placeholder='기업명 입력하기'
                        />
                      </AutoCompleteInputIntern>
                    </Form.Item>
                    <Form.Item name={[field.name, 'experienced_intern_id']} hidden={true}>
                      <Input />
                    </Form.Item>
                  </Form.Item>
                ))}
                <Form.Item noStyle={true}>
                  <Button
                    style={{ width: '200px', marginBottom: '20px' }}
                    disabled={intern}
                    onClick={() => add({ is_intern: true })}
                  >
                    기업명 입력하기
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </div>
      </StyledRow>

      <StyledRow>
        <div className='fullWidth' style={{ display: 'flex', flexDirection: 'column' }}>
          <div className='label' style={{ display: 'flex', justifyContent: 'space-between' }}>
            경력 (경력직이 아니라면 없음을 선택해주세요)
            <Checkbox
              className='green-border-checkbox'
              onChange={() => {
                setWorker((prev) => !prev);
                !worker && form.setFieldsValue({ experienced_worker: [] });
              }}
            >
              없음
            </Checkbox>
          </div>

          <Form.List name='experienced_worker'>
            {(fields, { add, remove }) => (
              <>
                {fields.map((field, index) => (
                  <Form.Item key={field.key} noStyle={true}>
                    <Form.Item
                      className='form-item community-selector'
                      name={[field.name, 'experienced_worker_name']}
                      rules={[{ required: true }]}
                    >
                      <AutoCompleteInputWorker
                        board='community'
                        defaultValue={
                          form.getFieldValue('experienced_worker')[field.name]['experienced_worker_name']
                        }
                        promise={communityAutoCompleteCompanyName}
                        form={form}
                        name={[field.name, 'experienced_worker_name']}
                        fieldIndex={field.name}
                      >
                        <Input
                          disabled={worker}
                          autoComplete='off'
                          size='large'
                          placeholder='기업명 입력하기'
                          name='testing'
                        />
                      </AutoCompleteInputWorker>
                    </Form.Item>
                    <Form.Item name={[field.name, 'experienced_worker_id']} hidden>
                      <Input />
                    </Form.Item>
                  </Form.Item>
                ))}
                <Form.Item noStyle={true}>
                  <Button
                    style={{ width: '200px', marginBottom: '20px' }}
                    disabled={worker}
                    onClick={() => add({ is_intern: false })}
                  >
                    기업명 입력하기
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </div>
      </StyledRow>

      <StyledRow>
        <div>
          <div className='fullWidth' style={{ display: 'flex', flexDirection: 'column' }}>
            <div className='label' onClick={() => console.log(form.getFieldValue('resume_file_id'))}>
              레주메 첨부하기
            </div>
            <Button onClick={() => setIsOnAttachmentModal((prev) => !prev)} style={{ width: '200px' }}>
              첨부하기
            </Button>
          </div>
          <AttachmentModal visible={isOnAttachmentModal} disabled={setIsOnAttachmentModal} form={form} />
          <Form.Item name='resume_files' rules={[{ required: true }]} />
        </div>
      </StyledRow>

      <StyledRow style={{ marginTop: '50px' }}>
        <div className='fullWidth'>
          <div className='label'>Fit 인터뷰에서 면접관을 설득시킨 본인만의 포인트는 무엇인가요?</div>
          <Form.Item
            className='form-item community-selector'
            name='first_interview_question'
            rules={[{ required: true }, { min: 150, message: '최소 150자 이상이어야 합니다' }]}
          >
            <TextArea
              autoSize={{ minRows: 6 }}
              size='large'
              placeholder='일관된 메시지와 이를 백업하는 다수의 사례를 전달한 것이 Fit에서 좋은 평가를 받는데 도움이 된 것 같습니다. 예를 들어 저만의 테마를 ‘집요함’으로 정하고, 나는 이런 사람이다 라는 메시지를 지속적으로 전달하려고 노력했습니다. 구체적인 예시로 나는 취미인 축구를 하더라도 마음에 들때까지 하려고 1년간 휴학을 하고 중앙동아리 주장을 하면서 전국 대회 수상을 했다던지, 이후 컨설팅을 진로로 정하기 전에 나랑 맞는 분야인지를 알기 위해 로컬, 대기업 인하우스, 글로벌 컨설팅 3종류 인턴을 해봤다던지 하는 스토리를 전달했습니다.'
            />
          </Form.Item>
        </div>
      </StyledRow>

      <StyledRow style={{ marginTop: '40px' }}>
        <div className='fullWidth'>
          <div className='label'>본인만의 케이스 공부법을 알려주세요</div>
          <Form.Item
            className='form-item community-selector'
            name='second_interview_question'
            rules={[{ required: true }, { min: 150, message: '최소 150자 이상이어야 합니다' }]}
          >
            <TextArea
              autoSize={{ minRows: 6 }}
              size='large'
              placeholder='뉴스 기사를 활용해 짧은 시간안에 나만의 구조를 만드는 연습이 도움되었습니다. 예시로, ‘2018년 월드컵 시즌 국내 카드 거래액 늘어’라는 제목의 주장글을 본 후 본문을 가리고 내 생각을 쓴 후 본문과 비교해보는 연습을 했습니다. 이 본문을 위 제목을 백업하기 위해 카드를 법인카드와 개인카드로 나눈 후 각 카드의 결제액 상승 이유를 상세히 설명했습니다. 좋은 기사는 주장을 백업하기위해 간결하고 잘 정리된 구조로 글이 구성되어 이슈트리 형태와 크게 다르지 않다고 느꼈습니다. 하루에 한 개씩 고민해보는 연습이 막바지에 크게 도움되었습니다.'
            />
          </Form.Item>
        </div>
      </StyledRow>

      <StyledRow style={{ marginTop: '40px' }}>
        <div className='fullWidth'>
          <div className='label'>취업준비에 가장 도움되었던 활동 및 경험을 공유해주세요</div>
          <Form.Item
            className='form-item community-selector'
            name='third_interview_question'
            rules={[{ required: true }, { min: 150, message: '최소 150자 이상이어야 합니다' }]}
          >
            <TextArea
              autoSize={{ minRows: 4 }}
              size='large'
              placeholder='Bain 인턴 경험이 가장 도움되었습니다. 컨설턴트가 실무를 어떻게 수행하는지, 어느정도 레벨로 분석을 진행하는지 알고 케이스를 푸는게 가장 중요하다고 생각합니다. 결국 케이스라는 것이 컨설턴트가 수행하는 작업의 단순화된 버전이니까요. 그래서 항상 1년차 어쏘 수준의 분석을 한다고 쉐도우 복싱을 하면서 케이스 풀이를 진행했습니다.'
            />
          </Form.Item>
        </div>
      </StyledRow>
    </StyledContainer>
  );
};

export default PassQualiticationWrite;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledRow = styled.div<TWidth>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: ${({ mobileWidth }) => (mobileWidth === 'row' ? '50%' : '100%')};

  @media screen and ${device.sm} {
    flex-direction: ${({ mobileWidth }) => (mobileWidth === 'row' ? 'row' : 'column')};
    align-items: flex-start;
  }

  input {
    border: none;
    border-radius: 8px;
    background-color: #f9f9f9;
    outline: none;
  }

  textarea {
    font-size: 14px;
  }

  .fullWidth {
    width: 100%;
  }

  .halfWidth {
    width: 50%;

    @media screen and ${device.sm} {
      width: 100%;
    }

    &:nth-child(2) {
      margin-left: 32px;

      @media screen and ${device.sm} {
        margin-left: ${({ mobileWidth }) => (mobileWidth === 'row' ? '32px' : 0)};
      }
    }
  }

  .label {
    margin-bottom: 7px;
  }

  .community-selector {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .ant-col.ant-form-item-control {
    width: 100%;
  }
`;
